import moment from 'moment';

export default {
  namespaced: true,
  state: {
    user: {
      // to store auth user data
      id: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      email: '',
      avatar: '',
      roles: [],
      color_theme: '',
      direction: '',
      locale: '',
      sidebar: ''
    },
    previousPage: null,
    is_auth: false, // to store auth status
    two_factor_code: null, // to store two factor code if required
    config: {}, // to store all configuration variables
    permissions: [], // to store all permissions of authenticated user
    last_activity: null, // to store last activity time of user
    default_role: {
      admin: '',
      user: ''
    }
  },
  mutations: {
    setAuthStatus(state) {
      state.is_auth = true;
    },
    setAuthUserDetail(state, auth) {
      for (let key of Object.keys(auth)) {
        state.user[key] = auth[key] !== null ? auth[key] : '';
      }
      if ('avatar' in auth)
        state.user.avatar = auth.avatar !== null ? auth.avatar : '';
      state.is_auth = true;
    //  state.user.roles = auth.roles;
    },
    setRoles(state, payload) {
      state.user.roles = payload;
    },
    resetAuthUserDetail(state) {
      for (let key of Object.keys(state.user)) {
        state.user[key] = '';
      }
      state.is_auth = false;
      state.user.roles = [];
      state.last_activity = null;
      localStorage.removeItem('auth_token');
      delete axios.defaults.headers.common['Authorization'];
    },
    setConfig(state, config) {
      if (!config) {
        return;
      }
      for (let key of Object.keys(config)) {
        state.config[key] = config[key];
      }
    },
    resetConfig(state) {
      for (let key of Object.keys(state.config)) {
        state.config[key] = '';
      }
    },
    setPermission(state, data) {
      state.permissions = [];
      if (data) {
        data.forEach(permission => state.permissions.push(permission.slug));
      }      
    },
    setTwoFactorCode(state, data) {
      state.two_factor_code = data;
    },
    resetTwoFactorCode(state) {
      state.two_factor_code = null;
    },
    setLastActivity(state) {
      state.last_activity = moment().format();
    },
    setDefaultRole(state, data) {
      state.default_role = data;
    },
    setPreviousPage(state, route) {
      state.previousPage = route;
    }
  },
  actions: {
    setAuthStatus({ commit }) {
      commit('setAuthStatus');
    },
    setAuthUserDetail({ commit }, auth) {
      commit('setAuthUserDetail', auth);
    },
    resetAuthUserDetail({ commit }) {
      commit('resetAuthUserDetail');
    },
    setConfig({ commit }, data) {
      commit('setConfig', data);
    },
    setPermission({ commit }, data) {
      commit('setPermission', data);
    },
    resetConfig({ commit }, data) {
      commit('resetConfig', data);
    },
    setTwoFactorCode({ commit }, data) {
      commit('setTwoFactorCode', data);
    },
    resetTwoFactorCode({ commit }) {
      commit('resetTwoFactorCode');
    },
    setLastActivity({ commit }) {
      commit('setLastActivity');
    },
    setDefaultRole({ commit }, data) {
      commit('setDefaultRole', data);
    }
  },
  getters: {
    getEmail: state => state.user.email,
    getAuthUser: state => name => {
      return state.user[name];
    },
    getAuthUserFullName: state => {
      return (
        state.user['first_name'] +
        (' ' + state.user['middle_name'] ? state.user['middle_name'] : '') +
        ' ' +
        state.user['last_name']
      );
    },
    getAuthStatus: state => {
      return state.is_auth;
    },
    hasRole: state => name => {
      return state.user.roles.indexOf(name) >= 0 ? true : false;
    },
    getConfig: state => name => {
      return state.config[name];
    },
    hasPermission: state => name => {
      function wildTest(wildcard, str) {
        wildcard = wildcard || '';
        const re = new RegExp(
          `^${wildcard
            .replace(/\./g, '.')
            .replace(/\*/g, '.*')
            .replace(/\?/g, '.')}$`,
          'i'
        );
        return re.test(str); // remove last 'i' above to have case sensitive
      }
      return !!state.permissions.find(item => wildTest(item, name));
    },
    getTwoFactorCode: state => {
      return state.two_factor_code;
    },
    getLastActivity: state => {
      return state.last_activity;
    },
    getDefaultRole: state => name => {
      return state.default_role[name];
    },
    wildTest(wildcard, str) {
      const re = new RegExp(
        `^${wildcard.replace(/\*/g, '.*').replace(/\?/g, '.')}$`,
        'i'
      );
      return re.test(str); // remove last 'i' above to have case sensitive
    },
    getInitials(state) {
      return (
        state.user['first_name'].charAt(0) + state.user['last_name'].charAt(0)
      );
    }
  }
};
